import { render, staticRenderFns } from "./PaceComponent.vue?vue&type=template&id=3c439c39&scoped=true&"
import script from "./PaceComponent.vue?vue&type=script&lang=js&"
export * from "./PaceComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaceComponent.vue?vue&type=style&index=0&id=3c439c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c439c39",
  null
  
)

export default component.exports